import { connect } from 'react-redux';
import { PlacingTypeSwitcher } from './PlacingTypeSwitcher';
import { IAppState, TActions } from '../../../../redux';
import { Dispatch } from 'redux';
import { IPlacingTypeSwitcherDispatchProps, IPlacingTypeSwitcherStateProps } from './types';
import { selectPlacingType } from '../../../../redux/reducers';
import { isShow } from './utils';
import { selectActivePlacingType } from '../../../../selectors/publishTerms';

export const mapStateToProps = (state: IAppState): IPlacingTypeSwitcherStateProps => ({
  isShow: isShow(state),
  value: selectActivePlacingType(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<TActions>): IPlacingTypeSwitcherDispatchProps => ({
  handleChange: (e, selectedPlacingType) => dispatch(selectPlacingType(selectedPlacingType)),
});

export const PlacingTypeSwitcherContainer = connect(mapStateToProps, mapDispatchToProps)(PlacingTypeSwitcher);
